import module from 'colaborador/module'
import template from './template.html'
import * as moment from 'moment'

export class ColaboradorCajaAhorroItemComponent {
  idProyecto
  idColaborador
  item
  importar
  onClose

  $onInit () {
    this.formatoFecha()
  }

  formatoFecha () {
    const HOY = new Date().getFullYear()
    this.item.fechaInicialFormato = moment(this.item.fechaInicial).format(this.item.fechaInicial.getFullYear() === HOY ? 'D [de] MMMM' : 'D [de] MMMM [de] YYYY')
    this.item.fechaFinalFormato = moment(this.item.fechaFinal).format(this.item.fechaFinal.getFullYear() === HOY ? 'D [de] MMMM' : 'D [de] MMMM [de] YYYY')
  }

  finalizar (data) {
    this.editando = false
    if (data) {
      this.item = data
      this.formatoFecha()
    }
  }

  eliminar () {
    this.eliminando = true
  }

  eliminado (data) {
    this.eliminando = false
    if (data) {
      this.onClose({$event: {data: this.item}})
    }
  }

  importarAportacion () {
    if (!this.importar) {
      return
    }
  }
}

module.component('colaboradorCajaAhorroItem', {
  controller: ColaboradorCajaAhorroItemComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    item: '<',
    importar: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/aportaciones/item/component.js